import { create } from "zustand";
import type { KbCitationTab, KbContentData } from "@/utils/knowledge-content";

export interface AnswerSideBarItem {
  id: number;
  url: string;
  title: string;
  content: string;
}

type AnswerSideBarStore = {
  isOpen: boolean;
  items: AnswerSideBarItem[];
  type: "answer-reference" | "paper-titles" | "paper-reference";
  openAnswerSideBar: () => void;
  closeAnswerSideBar: () => void;
  toggleAnswerSideBar: () => void;
  setItems: (items: AnswerSideBarItem[]) => void;
  addItem: (item: AnswerSideBarItem) => void;
  removeItem: (id: number) => void;
  clearItems: () => void;
  setType: (
    type: "answer-reference" | "paper-titles" | "paper-reference"
  ) => void;
  /** 열린 출처 버튼 구분용 (ReferenceButton/ReferenceTag 강조용) */
  selectedReferenceNumber: string | null;
  setSelectedReferenceNumber: (key: string | null) => void;
  /** true 면 Citation 을 External Ref. / Knowledge Base 탭 구조로 연다 */
  isKb: boolean;
  setIsKb: (isKb: boolean) => void;
  knowledgeContent: KbContentData | null;
  setKnowledgeContent: (data: KbContentData | null) => void;
  /** 열 때 지정한 Citation 탭. KbCitationContent 가 읽어 첫 탭을 맞춘다 */
  citationTab: KbCitationTab | null;
  setCitationTab: (tab: KbCitationTab | null) => void;
};

const useAnswerSideBarStore = create<AnswerSideBarStore>((set) => ({
  isOpen: false,
  items: [],
  type: "answer-reference",
  selectedReferenceNumber: null,
  setSelectedReferenceNumber: (key: string | null) =>
    set({ selectedReferenceNumber: key }),
  isKb: false,
  setIsKb: (isKb: boolean) => set({ isKb }),
  knowledgeContent: null,
  setKnowledgeContent: (data: KbContentData | null) =>
    set({ knowledgeContent: data }),
  citationTab: null,
  setCitationTab: (tab: KbCitationTab | null) => set({ citationTab: tab }),
  openAnswerSideBar: () => set({ isOpen: true }),
  /* isKb 와 knowledgeContent 는 닫을 때 비우지 않는다. 닫히는 300ms 동안 내용이 바뀌어 보이고,
     여는 쪽(handleAnswerSideBarOpen)이 매번 다시 넣는다 */
  closeAnswerSideBar: () => set({ isOpen: false, selectedReferenceNumber: null }),
  toggleAnswerSideBar: () =>
    set((state) => ({
      isOpen: !state.isOpen,
      selectedReferenceNumber: state.isOpen ? null : state.selectedReferenceNumber,
    })),
  setItems: (items: AnswerSideBarItem[]) => set({ items }),
  addItem: (item: AnswerSideBarItem) => {
    set((state) => ({ items: [...state.items, item] }));
  },

  removeItem: (id: number) =>
    set((state) => ({ items: state.items.filter((item) => item.id !== id) })),
  clearItems: () => set({ items: [] }),
  setType: (type: "answer-reference" | "paper-titles" | "paper-reference") =>
    set({ type }),
}));

export default useAnswerSideBarStore;
